import { Button, ButtonColor, ButtonSize, ButtonVariant } from "@swivl-mono/ui";
import { useLocation, useNavigate } from "react-router-dom";

import { buildRequestAccessMailtoHref } from "../../Helpers/RequestAccessMailto";
import AccountModel from "../../Models/Account/AccountModel";

// Shown only to a visitor with no session at all on an access-token page.
export function AnonymousAccessNavBar() {
  const account = AccountModel.useState((s) => s.account);
  const navigate = useNavigate();
  const location = useLocation();

  if (account) return null;

  const handleLogIn = (): void => {
    navigate(`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`);
  };

  const handleRequestAccess = (): void => {
    window.location.href = buildRequestAccessMailtoHref();
  };

  return (
    <div className="flex items-center justify-end gap-2 border-b border-grey-200 bg-white px-4 py-2">
      <Button variant={ButtonVariant.GHOST} size={ButtonSize.SMALL} onClick={handleRequestAccess}>
        Request Access
      </Button>
      <Button color={ButtonColor.ORANGE} size={ButtonSize.SMALL} onClick={handleLogIn}>
        Log In
      </Button>
    </div>
  );
}
